// Checkout veloce (devops #374): chi non ha un account paga con nome, cognome, e-mail, codice fiscale e termini.
// Attivo solo a build-time con VUE_APP_QUICK_CHECKOUT=true, e va acceso insieme al flag lato server
// (`elitefitness.checkout-signup.enabled`): con il server spento l'endpoint risponde 404 e il form lo dichiara.
// Senza il flag il checkout resta quello di sempre (registrazione completa + verifica e-mail).
export const QUICK_CHECKOUT = process.env.VUE_APP_QUICK_CHECKOUT === 'true';
